import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { createClubEvent, updateClubEvent, getClubEvent } from '../../../api/ClubEventsAPI';
import AppBreadCrumb from '../../common/AppBreadCrumb';
import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';

const ClubEventForm = ({ mode = 'create' }) => {
    const { clubEventId } = useParams();
    const navigate = useNavigate();
    const isEditMode = mode === 'edit';

    const [event, setEvent] = useState({
        name: '',
        description: '',
        start_time: '',
        end_time: '',
        location: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    useEffect(() => {
        if (isEditMode) {
            setIsLoading(true);
            getClubEvent(clubEventId, (data) => {
                setIsLoading(false);
                if (data) {
                    const formatForInput = (date) => date ? new Date(new Date(date).getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().slice(0, 16) : '';
                    setEvent({
                        ...data,
                        start_time: formatForInput(data.start_time),
                        end_time: formatForInput(data.end_time),
                    });
                }
            });
        }
    }, [clubEventId, isEditMode]);

    const handleChange = (e) => {
        setEvent({ ...event, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        setErrors({});

        const apiCall = isEditMode 
            ? updateClubEvent(clubEventId, event, handleResponse) 
            : createClubEvent(event, handleResponse);
    };
    
    const handleResponse = (response) => {
        setIsLoading(false);
        if (response.id) {
            navigate('/club_portal/club-events', { state: { message: `Event ${isEditMode ? 'updated' : 'created'} successfully!` } });
        } else {
            handleApiError(response, setErrors, setToaster, setShowToaster);
        }
    };

    if (isLoading && isEditMode) return <div className="text-center p-5"><div className="spinner-border"></div></div>;

    return (
        <main>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <div className="container-fluid">
                <AppBreadCrumb title={isEditMode ? `Edit Event: ${event.name}` : 'Create New Event'} />
                <div className="card">
                    <div className="card-header">
                        <h5>Event Details</h5>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit} noValidate>
                            <div className="mb-3">
                                <label className="form-label">Event Name</label>
                                <input name="name" value={event.name} onChange={handleChange} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                                {errors.name && <div className="invalid-feedback">{errors.name[0]}</div>}
                            </div>
                            
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Start Time</label>
                                    <input type="datetime-local" name="start_time" value={event.start_time} onChange={handleChange} className={`form-control ${errors.start_time ? 'is-invalid' : ''}`} />
                                    {errors.start_time && <div className="invalid-feedback">{errors.start_time[0]}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">End Time</label>
                                    <input type="datetime-local" name="end_time" value={event.end_time} onChange={handleChange} className={`form-control ${errors.end_time ? 'is-invalid' : ''}`} />
                                    {errors.end_time && <div className="invalid-feedback">{errors.end_time[0]}</div>}
                                </div>
                            </div>
                            
                            <div className="mb-3">
                                <label className="form-label">Location</label>
                                <input name="location" value={event.location || ''} onChange={handleChange} className={`form-control ${errors.location ? 'is-invalid' : ''}`} />
                                {errors.location && <div className="invalid-feedback">{errors.location[0]}</div>}
                            </div>
                            
                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea name="description" value={event.description || ''} onChange={handleChange} className={`form-control ${errors.description ? 'is-invalid' : ''}`} rows="4"></textarea>
                                {errors.description && <div className="invalid-feedback">{errors.description[0]}</div>}
                            </div>

                            <div className="text-end mt-4">
                                <button type="button" onClick={() => navigate('/club_portal/club-events')} className="btn btn-secondary me-2">Cancel</button>
                                <button type="submit" className="btn btn-primary" disabled={isLoading}>{isLoading ? 'Saving...' : 'Save Event'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ClubEventForm;